import styled from 'styled-components';

export type DataListProps = {
  $size: 1 | 2 | 3;
};

export const DataList = styled.div<DataListProps>`
  display: flex;
  flex: 1;

  flex-direction: column;
  gap: ${({ theme, $size }) => theme.spacing[$size + 2]}px;
`;
